// eslint-disable-next-line @typescript-eslint/no-unused-vars -- It is just a type for now, but might be exported later
const languages = ["NOB", "SWE", "ENG"] as const;
export type Language = (typeof languages)[number];

export const languageToName = {
  NOB: "Norsk",
  SWE: "Svensk",
  ENG: "Engelsk",
} as const;

export const countryCodeToLanguage = {
  NO: "NOB",
  SE: "SWE",
  EN: "ENG", // Not necessary, but doesnt hurt to include either
} as const;
